import './new-agent.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormAgent from "../form-agent/form-agent";
import { useNewAgent } from './new-agent.hook';

export function NewAgent() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewAgent();

  return (
    <div id="NewAgent" className="agent">
      <HeaderContent
        title={<h1>New Agent</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormAgent />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewAgent;